import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../styles/color";
import Divider from "@mui/material/Divider";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { BackButton } from "../assets/icons";
import { CustomContainer } from "../components/CustomContainer";
import { StoreChannel } from "../components/common/StoreChannel";
import { Helmet } from "react-helmet-async";

const ChannelDetails = () => {
  const [show, setShow] = React.useState(false);
  const [cameFromAccountSetup, setCameFromAccountSetup] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  //! Hooks
  const [_, __, removeAccessTokenToken] = useCookies([
    "accessToken",
    "refreshToken",
    "googleToken",
    "role",
  ]);

  // Check if user came from account-setup
  useEffect(() => {
    const referrer = document.referrer;
    const currentPath = window.location.pathname;

    if (currentPath === "/youtube-channel") {
      // Check if there's a state indicating we came from account-setup
      if (
        location.state?.fromAccountSetup ||
        referrer.includes("account-setup")
      ) {
        setCameFromAccountSetup(true);
      }
    }
  }, [location]);

  //! Variables
  return (
    <>
      <Helmet>
        <title>Set Up Your YouTube Channel Details for Brand Collabs</title>
        <meta
          name="description"
          content="Configure your YouTube channel in the QuickFluence dashboard for secure access, smarter brand collaborations, and smooth, data-driven campaign results."
        />
        {/* Canonical */}
        <link rel="canonical" href="https://quickfluence.com/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="YouTube Setup for Creators | QuickFluence Dashboard"
        />
        <meta
          property="og:description"
          content="Configure your YouTube channel in the QuickFluence dashboard for secure access, smarter brand collaborations, and smooth, data-driven campaign results."
        />

        <meta property="og:url" content="https://quickfluence.com/" />
        <meta property="og:site_name" content="quickfluence" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="QuickFluence YouTube channel settings dashboard"
        />
        <meta
          property="og:image"
          content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <CustomContainer>
        <>
          <Box
            sx={{
              background: colors.dark[800],
              borderTopRightRadius: "24px",
              borderTopLeftRadius: "24px",
              color: "white",
              p: { md: "30px 30px", xs: "20px 15px" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <Box sx={{ flex: { md: "0 0 35%", xs: "0 0 30%" } }}>
                <Button
                  variant="text"
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                >
                  <BackButton />
                </Button>
              </Box>
              <Box sx={{ flex: { md: "0 0 40%", xs: "0 0 52%" } }}>
                <Typography
                  sx={{ fontSize: { md: "20px", xs: "15px" } }}
                  fontWeight={600}
                  variant="h1"
                >
                  Setup YouTube channel details
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              "& .MuiDivider-root": {
                borderTop: `1px solid ${colors.dark[100]}`,
              },
            }}
          >
            <Divider sx={{ color: colors.gray[300] }} />
          </Box>
          <Box
            sx={{
              height: "100%",
              borderTopRightRadius: "0px",
              borderTopLeftRadius: "0px",
              borderBottomRightRadius: "24px",
              borderBottomLeftRadius: "24px",
              background: colors.dark[800],
              color: "white",
              p: { md: "20px 100px", xs: "20px 10px" },
            }}
          >
            <StoreChannel
              show={show}
              setShow={setShow}
              cameFromAccountSetup={cameFromAccountSetup}
            />
          </Box>
        </>
      </CustomContainer>
    </>
  );
};

export default ChannelDetails;
